var React = require('react');

function CoffeeHouse (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#FFF"},React.createElement("path",{"d":"M1454-374.802L1042.748 333.5 1454 706V-374.802z","transform":"translate(-1042)"}))));
}

CoffeeHouse.defaultProps = {"preserveAspectRatio":"none","width":"398","height":"694","viewBox":"0 0 398 694"};

module.exports = CoffeeHouse;

CoffeeHouse.default = CoffeeHouse;
